import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserActionSettingChanged } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';
import { SetTagActionSettingRemoteDto } from 'src/generated/signalR/set-tag-action-setting-remote-dto';
import { ActionSpecificSettingsComponent } from '../action-specific-settings-component';

@Component({
   selector: 'samweb-set-tag-action-settings',
   templateUrl: './set-tag-action-settings.component.html',
   styleUrls: ['./set-tag-action-settings.component.scss'],
})
export class SetTagActionSettingsComponent extends ActionSpecificSettingsComponent implements OnInit {
   public actionSetting$: Observable<SetTagActionSettingRemoteDto>;

   constructor(private store: Store) {
      super();
   }

   ngOnInit(): void {
      this.actionSetting$ = this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(
         map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)),
         map((x) => x as SetTagActionSettingRemoteDto),
         map((x) => _.cloneDeep(x))
      );
   }

   tagNameChanged(settings: SetTagActionSettingRemoteDto, newTagName: string) {
      settings.tagName = newTagName;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }

   tagValueChanged(settings: SetTagActionSettingRemoteDto, newTagValue: string) {
      settings.tagValue = newTagValue;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }
}
